{
  "it": {
    "announcement": {
      "actions": {
        "delete_announcement": "Elimina novità",
        "edit": "Modifica",
        "new": "Novità",
        "pin": "Fissa in cima",
        "save": "Salva",
        "submit": "Pubblica",
        "unpin": "Rimuovi dalla cima"
      },
      "attributes": {
        "description": "Descrizione"
      },
      "labels": {
        "allUnits": "tutte le unità",
        "customers": "clienti",
        "for": "per",
        "image_tab": "Immagine",
        "notSeenYet": "Non ancora vista",
        "now": "Ora",
        "pinned": "Questa novità viene mostrata in cima alla pagina del cliente.",
        "pinnedBadge": "Fissata",
        "seen": "Vista",
        "seenByCount": "Vista da {count} di {total}",
        "sharedWithPrefix": "Condivisa con",
        "sharedWithProject": "Condivisa con {units} di {project}",
        "someUnits": "alcune unità",
        "start": "Inizio",
        "unitsCount": "1 unità | {count} unità",
        "video_tab": "Video",
        "youtube_video": "URL del video YouTube"
      },
      "name": "Novità",
      "placeholders": {
        "customers": {
          "none": {
            "subtitle": "Presto troverà aggiornamenti regolari sul cantiere nella Sua dashboard.",
            "title": "Trovi qui le Sue novità"
          }
        },
        "employees": {
          "new": {
            "subtitle": "Dia il benvenuto ai Suoi clienti o condivida un aggiornamento sul progetto.",
            "title": "Crei la Sua prima novità"
          },
          "none": {
            "project_required": "Selezioni un progetto",
            "selectProject": "Selezioni un progetto e inizi a creare",
            "subtitle": "Dia il benvenuto ai Suoi clienti o condivida un aggiornamento su un progetto qualsiasi."
          },
          "paste_video_url": "Incolli qui il Suo link di YouTube"
        }
      },
      "toasts": {
        "create": "Novità pubblicata",
        "delete": "Novità eliminata",
        "invalid_video": "Non è un video YouTube valido",
        "update": "La novità è stata aggiornata"
      },
      "validation": {
        "pleaseAddContent": "Aggiunga un'immagine, un video o una descrizione"
      }
    }
  }
}
